import React from 'react';
import { IconType } from 'react-icons/lib';
import { ActionButton } from './action_button';
import { Container } from './styles';

interface Action {
  label: string;
  icone: IconType;
  visible: boolean;
  color: string;
  text_color: string;
  onClick?: () => void;
}

interface Props {
  actions: Action[];
  loading?: boolean;
}

const ActionGroup: React.FC<Props> = (props) => {
  return (
    <Container>
      {props.actions.map(
        (action, index) =>
          action.visible && (
            <ActionButton
              key={index}
              onClick={action.onClick}
              color={action.color}
              label={action.label}
              disabled={props.loading}
            >
              <action.icone color={action.text_color} size={14} />
            </ActionButton>
          )
      )}
    </Container>
  );
};

export { ActionGroup };
export type { Action };
